import { makeStyles } from '@material-ui/core/styles';
import { RAIL_ON_TOP_BELOW } from 'core/components/layout-with-sidebar/layout-with-sidebar.styles';

// Sizes follow the "Reimagined from scratch" prototype's quote steps; colors come from the new look's tokens.
// Where the layout puts the rail above the content, the steps sit side by side.
export default makeStyles((theme) => ({
  steps: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    [`@media (max-width: ${theme.screens[RAIL_ON_TOP_BELOW] - 1}px)`]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      '& > li': { flex: '1 1 200px', alignSelf: 'flex-start' }
    }
  },
  step: {
    borderLeft: '3px solid transparent',
    borderRadius: theme.sizes.innerCorners
  },
  activeStep: {
    borderLeftColor: theme.colorPalette.green_75,
    backgroundColor: theme.colorPalette.white
  },
  stepButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    width: '100%',
    padding: theme.spacing(3),
    border: 0,
    background: 'none',
    font: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
    color: theme.colorPalette.green_100
  },
  number: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 26,
    height: 26,
    border: `1px solid ${theme.colorPalette.beige_60}`,
    borderRadius: '50%',
    fontSize: 13
  },
  previous: {
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    borderColor: theme.colorPalette.green_100
  },
  stepText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0
  },
  title: {
    fontSize: 15,
    fontWeight: 500
  },
  hint: {
    fontSize: 12,
    color: theme.colors.text_secondary
  }
}));
